"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "ja": {
        "translation": {
            "left_navigation": {
                "loading": "読み込み中",
                "hidden_target": "適用されているフィルターにより、選択肢を表示できません。この項目を表示するには、該当するフィルターを解除します。",
                "sidenav_open": "ナビゲーションを開く",
                "sidenav_close": "ナビゲーションを閉じる",
                "expand": "展開する",
                "collapse": "折りたたむ",
                "small_search": "検索するには文字を 2 つ以上入力してください。",
                "no_search_results": "検索結果が見つかりませんでした。",
                "filter_search": "フィルター...",
                "collection_archive": "コレクションのアーカイブ",
                "activities": {
                    "title": "活動",
                    "details": "詳細",
                    "reset": "再設定",
                    "load_more": "さらに読み込む",
                    "no_results": "指定されたフィルターに活動がありません。",
                    "no_more_results": "指定されたフィルターの活動の最後に到達しました。",
                    "actions": {
                        "created": "作成",
                        "deleted": "削除済み",
                        "updated": "更新済み"
                    }
                },
                "settings": {
                    "title": "設定"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=ja.js.map